export const ChevronSort = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.2867 20.2469L15.9545 26.579L9.67626 20.3007" stroke="currentColor" stroke-width="2"/>
<path d="M9.67627 11.7539L16.0085 5.42176L22.2867 11.7" stroke="currentColor" stroke-width="2"/>
</svg>`;
